// Dynamic backend routing based on channel type
// DIVA (web, mobile) -> DIVA backend
// CPDIVA (channelpartners) -> CP-DIVA backend

// Production URLs - update these when deploying
const normalizeBaseUrl = (url) => (url || '').replace(/\/+$/, '');

const DIVA_BASE_URL = normalizeBaseUrl(process.env.REACT_APP_DIVA_API_BASE) || 'http://localhost:5000';  // https://diva-uat-api.dtdc.com
const CPDIVA_BASE_URL = normalizeBaseUrl(process.env.REACT_APP_CPDIVA_API_BASE) || 'http://localhost:5001'; // https://cpdiva-uat-api.dtdc.com

export const getBackendConfig = (channelType) => {
  const normalizedChannelType = (channelType || '').toString().trim().toLowerCase();
  const isDiva = normalizedChannelType === 'web' || normalizedChannelType === 'mob' || !normalizedChannelType;
  const baseURL = isDiva ? DIVA_BASE_URL : CPDIVA_BASE_URL;
  const prefix = isDiva ? 'diva' : 'cpdiva';
  
  return {
    backendURL: `${baseURL}/${prefix}/${isDiva ? 'get-dtdc-agent-response' : 'get-cpdiva-agent-response'}`,
    backendBaseURL: baseURL,
    feedbackURL: `${baseURL}/${prefix}/feedback`,
    closeSessionURL: `${baseURL}/${prefix}/close-session`,
    welcomeMessageURL: `${baseURL}/${prefix}/welcome-message`
  };
};

// Legacy exports for backward compatibility (defaults to DIVA)
export var backendURL = `${DIVA_BASE_URL}/diva/get-dtdc-agent-response`;
export var backendBaseURL = DIVA_BASE_URL;
export var feedbackURL = `${DIVA_BASE_URL}/diva/feedback`;
export var closeSessionURL = `${DIVA_BASE_URL}/diva/close-session`;
export var welcomeMessageURL = `${DIVA_BASE_URL}/diva/welcome-message`;
